/* Assistenza — pannelli e FAQ (sections/tc-help.liquid).
   Stesso comportamento della vecchia pagina: ogni pannello si apre/chiude da solo;
   nelle FAQ si apre una domanda alla volta. Click o Invio/Spazio. */
(function () {
  "use strict";

  var root = document.querySelector("[data-tc-help]");
  if (!root) return;

  function toggleCard(card) {
    var isActive = card.classList.contains("active");
    card.classList.toggle("active", !isActive);
    var header = card.querySelector(".tc-help__head");
    if (header) header.setAttribute("aria-expanded", String(!isActive));
  }

  function toggleFaqItem(item, group) {
    var isActive = item.classList.contains("active");
    group.forEach(function (i) {
      i.classList.remove("active");
      var q = i.querySelector(".tc-help__qhead");
      if (q) q.setAttribute("aria-expanded", "false");
    });
    if (!isActive) {
      item.classList.add("active");
      var q = item.querySelector(".tc-help__qhead");
      if (q) q.setAttribute("aria-expanded", "true");
    }
  }

  function bind(el, action) {
    el.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); action(); });
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); action(); }
    });
  }

  /* Pannelli (uno per volta ciascuno) */
  root.querySelectorAll(".tc-help__card").forEach(function (card) {
    var header = card.querySelector(".tc-help__head");
    if (header) bind(header, function () { toggleCard(card); });
  });

  /* FAQ (accordion a apertura singola) */
  var faqItems = Array.prototype.slice.call(root.querySelectorAll(".tc-help__q"));
  faqItems.forEach(function (item) {
    var question = item.querySelector(".tc-help__qhead");
    if (question) bind(question, function () { toggleFaqItem(item, faqItems); });
  });
})();
